import React, { useState } from "react";
import { PaziaTooltip } from "components/atoms";

type AdminSearchInputProps = {
  onSearch: (searchPhrase: string) => void;
  className?: string;
  tooltip?: string;
};

export const AdminSearchInput = ({ onSearch, className, tooltip }: AdminSearchInputProps): JSX.Element => {
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [searchTimeout, setSearchTimeout] = useState<any>(null);

  const searchDelay = 750; // Set delay to 0

  const performSearch = (value: string) => {
    try {
      onSearch(value);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (searchTimeout) clearTimeout(searchTimeout);

    const timeout = setTimeout(() => performSearch(value), searchDelay);
    setSearchTimeout(timeout);
  };

  return (
    <div className={`flex max-w-sm w-full ${className ?? ""} relative`}>
      <label htmlFor="profile-search" className="sr-only">
        Szukaj
      </label>
      <input
        id="profile-search"
        className="form-input w-full pl-9 bg-white dark:bg-slate-800"
        type="search"
        placeholder="Szukaj..."
        value={searchTerm}
        onChange={handleInputChange}
      />
      <button className="absolute inset-0 right-auto group" type="submit" aria-label="Search">
        <svg
          className="w-4 h-4 shrink-0 fill-current text-slate-400 dark:text-slate-500 group-hover:text-slate-500 dark:group-hover:text-slate-400 ml-3 mr-2"
          viewBox="0 0 16 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zM7 2C4.243 2 2 4.243 2 7s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z" />
          <path d="M15.707 14.293L13.314 11.9a8.019 8.019 0 01-1.414 1.414l2.393 2.393a.997.997 0 001.414 0 .999.999 0 000-1.414z" />
        </svg>
      </button>
      {tooltip && <PaziaTooltip className="ml-2" description={tooltip} />}
    </div>
  );
};
